import React, { useEffect, useState } from 'react';

// Le film de chantier en fond de la hero.
// Il est muet, il boucle, et il ne se lance pas si le visiteur a demande a
// reduire les animations dans les reglages de son systeme : dans ce cas on
// affiche la premiere image, qui sert aussi d'affiche pendant le chargement.

export default function FilmHero() {
  const [anime, setAnime] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const suivre = () => setAnime(!mq.matches);
    suivre();
    mq.addEventListener('change', suivre);
    return () => mq.removeEventListener('change', suivre);
  }, []);

  return (
    <>
      <div className="film" aria-hidden="true">
        {anime ? (
          <video
            src="/video/hero-chantier.mp4"
            poster="/images/hero-poster.webp"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
        ) : (
          <img src="/images/hero-poster.webp" alt="" />
        )}
      </div>
      <span className="film-voile" aria-hidden="true" />
    </>
  );
}
